import { facebookPublicAppId } from 'js/config'
import React from 'react'
import { Title, Meta } from 'react-head'

import { DatoSEOMetaTag } from '../../../typings'

type Props = {
  meta: DatoSEOMetaTag[]
  fallbackDescription?: string
  fallbackImage?: string
  canonicalUrl?: string
}

export default function DatoMeta({
  meta,
  fallbackDescription,
  fallbackImage,
  canonicalUrl,
}: Props) {
  const hasDescription = meta.some(
    ({ attributes }) => attributes?.name === 'description',
  )
  const hasImage = meta.some(
    ({ attributes }) => attributes?.name === 'og:image',
  )
  const fallback: Array<{
    tag: 'meta'
    content: null
    attributes:
      | { name: string; content: string }
      | { property: string; content: string }
  }> = []

  if (fallbackDescription && !hasDescription) {
    ;['description', 'og:description', 'twitter:description'].forEach(
      (name) => {
        fallback.push({
          attributes: {
            name: name,
            content: fallbackDescription,
          },
          content: null,
          tag: 'meta',
        })
      },
    )
  }

  if (fallbackImage && !hasImage) {
    ;['og:image', 'twitter:image'].forEach((name) => {
      fallback.push({
        attributes: {
          name: name,
          content: fallbackImage,
        },
        content: null,
        tag: 'meta',
      })
    })
  }

  if (canonicalUrl) {
    fallback.push({
      tag: 'meta',
      content: null,
      attributes: {
        property: 'og:url',
        content: canonicalUrl,
      },
    })
  }

  fallback.push({
    tag: 'meta',
    content: null,
    attributes: {
      property: 'fb:app_id',
      content: facebookPublicAppId as string,
    },
  })

  return (
    <>
      {[...meta, ...fallback].map(({ tag, attributes, content }, i) => {
        if (tag === 'title') return <Title key={i}>{content} - Lifesum</Title>

        return <Meta {...attributes} key={i} />
      })}
    </>
  )
}
